import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, vShow as _vShow } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "flex items-center justify-between gap-2"
};
const _hoisted_4 = {
  class: "data-table-shell"
};
const _hoisted_5 = {
  class: "data-table-scroll"
};
const _hoisted_6 = {
  class: "data-table"
};
const _hoisted_7 = {
  class: "data-table-body"
};
const _hoisted_8 = ["data-id", "data-has-children"];
const _hoisted_9 = {
  class: "data-table-td"
};
const _hoisted_10 = {
  class: "flex items-center gap-1"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  key: 1,
  class: "w-4 h-4"
};
const _hoisted_13 = {
  class: "text-sm font-medium text-slate-900"
};
const _hoisted_14 = {
  class: "data-table-td is-center"
};
const _hoisted_15 = {
  key: 1,
  class: "w-5 h-5 text-slate-500 mx-auto",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_16 = {
  class: "data-table-td"
};
const _hoisted_17 = {
  class: "data-table-td text-sm text-slate-900"
};
const _hoisted_18 = {
  class: "data-table-td text-sm text-slate-500"
};
const _hoisted_19 = {
  class: "data-table-td"
};
const _hoisted_20 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_21 = {
  class: "flex items-center gap-1"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["data-parent-id"];
const _hoisted_26 = {
  class: "data-table-td"
};
const _hoisted_27 = {
  class: "flex items-center gap-1 pl-8"
};
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  key: 1,
  class: "w-4 h-4"
};
const _hoisted_30 = {
  key: 2,
  class: "w-4 h-4 text-slate-400",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
const _hoisted_31 = {
  key: 3,
  class: "w-4 h-4 text-blue-500",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
const _hoisted_32 = {
  class: "text-sm text-slate-900"
};
const _hoisted_33 = {
  class: "data-table-td is-center"
};
const _hoisted_34 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_35 = {
  key: 2,
  class: "w-5 h-5 text-slate-500 mx-auto",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_36 = {
  class: "data-table-td"
};
const _hoisted_37 = {
  class: "data-table-td text-sm text-slate-900"
};
const _hoisted_38 = {
  class: "data-table-td text-sm text-slate-500"
};
const _hoisted_39 = {
  class: "data-table-td"
};
const _hoisted_40 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_41 = {
  class: "flex items-center gap-1"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = ["onClick"];
const _hoisted_44 = ["onClick"];
const _hoisted_45 = ["data-parent-id"];
const _hoisted_46 = {
  class: "data-table-td"
};
const _hoisted_47 = {
  class: "flex items-center gap-1 pl-16"
};
const _hoisted_48 = {
  key: 0,
  class: "w-4 h-4 text-slate-400",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
const _hoisted_49 = {
  key: 1,
  class: "w-4 h-4 text-indigo-500",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
const _hoisted_50 = {
  class: "text-sm text-slate-900"
};
const _hoisted_51 = {
  class: "data-table-td is-center"
};
const _hoisted_52 = {
  key: 0,
  class: "text-xs text-slate-400"
};
const _hoisted_53 = {
  key: 2,
  class: "w-5 h-5 text-slate-500 mx-auto",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_54 = {
  class: "data-table-td"
};
const _hoisted_55 = {
  class: "data-table-td text-sm text-slate-900"
};
const _hoisted_56 = {
  class: "data-table-td text-sm text-slate-500"
};
const _hoisted_57 = {
  class: "data-table-td"
};
const _hoisted_58 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_59 = {
  class: "flex items-center gap-1"
};
const _hoisted_60 = ["onClick"];
const _hoisted_61 = ["onClick"];
const _hoisted_62 = ["onClick"];
const _hoisted_63 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_64 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_65 = {
  class: "p-6 space-y-4"
};
const _hoisted_66 = ["value"];
const _hoisted_67 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_68 = ["value"];
const _hoisted_69 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_70 = {
  class: "flex items-center gap-2"
};
const _hoisted_71 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_72 = {
  class: "p-6"
};
const _hoisted_73 = {
  class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-xl"
};
import { ref, reactive, onMounted, markRaw } from 'vue';
import { ElMessage } from 'element-plus';
import * as HeroIcons from '@heroicons/vue/24/outline';
import { getMenuTree, createMenu, updateMenu, deleteMenu as removeMenu } from '@/api/menu';
import ListPageShell from '@/components/ListPageShell.vue';
import IconSelector from './components/IconSelector.vue';
import AppModal from '@/components/AppModal.vue';

// Create icon component map (keep consistent with AppSidebar)
const TYPE_CATALOG = 0;
const TYPE_MENU = 1;
const TYPE_BUTTON = 2;

// API状态常量 (0-正常)
const STATUS_NORMAL = 0;

// 加载菜单树

export default {
  __name: 'MenuManagement',
  setup(__props) {
    const iconComponents = {};
    Object.keys(HeroIcons).forEach(name => {
      const iconName = name.replace(/Icon$/, '').replace(/([A-Z])/g, '-$1').toLowerCase().replace(/^-/, '');
      iconComponents[iconName] = markRaw(HeroIcons[name]);
    });

    // Get icon component
    function getIconComponent(iconName) {
      if (!iconName) return null;
      return iconComponents[iconName] || null;
    }

    // 菜单数据
    const menuTree = ref([]);
    const loading = ref(false);

    // API类型常量 (0-目录, 1-菜单, 2-按钮)
    async function fetchMenuTree() {
      loading.value = true;
      try {
        const data = await getMenuTree();
        menuTree.value = data || [];
        // 默认展开所有有子节点的
        expandedIds.value = menuTree.value.filter(m => m.children && m.children.length > 0).map(m => m.id);
      } catch (error) {
        ElMessage.error(error.message || '获取菜单列表失败');
      } finally {
        loading.value = false;
      }
    }
    onMounted(() => {
      fetchMenuTree();
    });

    // 展开/折叠状态
    const expandedIds = ref([]);
    const allExpanded = ref(false);

    // 模态框状态
    const showModal = ref(false);
    const showDeleteModal = ref(false);
    const showIconSelector = ref(false);
    const isEdit = ref(false);
    const pendingDelete = ref(null);

    // 表单数据
    const form = reactive({
      id: '',
      name: '',
      type: TYPE_CATALOG,
      status: STATUS_NORMAL,
      visible: 0,
      path: '',
      sort: 1,
      perms: '',
      component: '',
      icon: '',
      parentId: '',
      parentName: '',
      isCache: 0,
      isFrame: 0,
      redirect: ''
    });

    // 切换单个树节点
    function toggleTree(menuId) {
      const index = expandedIds.value.indexOf(menuId);
      if (index > -1) {
        expandedIds.value.splice(index, 1);
      } else {
        expandedIds.value.push(menuId);
      }
    }

    // 展开/折叠所有
    function toggleAllTrees() {
      allExpanded.value = !allExpanded.value;
      if (allExpanded.value) {
        expandedIds.value = menuTree.value.filter(m => m.children && m.children.length > 0).map(m => m.id);
      } else {
        expandedIds.value = [];
      }
    }

    // 获取类型样式
    function getTypeClass(type) {
      const classes = {
        [TYPE_CATALOG]: 'status-badge is-warning',
        [TYPE_MENU]: 'status-badge is-info',
        [TYPE_BUTTON]: 'status-badge is-neutral'
      };
      return classes[type] || 'status-badge is-neutral';
    }

    // 获取类型文本
    function getTypeText(type) {
      const texts = {
        [TYPE_CATALOG]: '目录',
        [TYPE_MENU]: '菜单',
        [TYPE_BUTTON]: '按钮'
      };
      return texts[type] ?? type;
    }

    // 打开新增顶层菜单模态框
    function openAddRootModal() {
      isEdit.value = false;
      form.id = '';
      form.parentId = 0;
      form.parentName = '';
      form.name = '';
      form.type = TYPE_CATALOG;
      form.status = STATUS_NORMAL;
      form.visible = 0;
      form.path = '';
      form.sort = 1;
      form.perms = '';
      form.component = '';
      form.icon = '';
      form.isCache = 0;
      form.isFrame = 0;
      form.redirect = '';
      showModal.value = true;
    }

    // 打开新增模态框
    function openAddModal(menu) {
      isEdit.value = false;
      form.id = '';
      form.parentId = menu.id;
      form.parentName = menu.name;
      form.name = '';
      form.type = TYPE_CATALOG;
      form.status = STATUS_NORMAL;
      form.visible = 0;
      form.path = '';
      form.sort = 1;
      form.perms = '';
      form.component = '';
      form.icon = '';
      form.isCache = 0;
      form.isFrame = 0;
      form.redirect = '';
      showModal.value = true;
    }

    // 打开编辑模态框
    function openEditModal(menu) {
      isEdit.value = true;
      form.id = menu.id;
      form.name = menu.name;
      form.type = menu.type;
      form.status = menu.status;
      form.visible = menu.visible ?? 1;
      form.path = menu.path || '';
      form.sort = menu.sort || 1;
      form.perms = menu.perms || '';
      form.component = menu.component || '';
      form.icon = menu.icon || '';
      form.parentId = menu.parentId || '';
      form.parentName = menu.parentId === 0 ? '' : getParentName(menu.id);
      form.isCache = menu.isCache ?? 0;
      form.isFrame = menu.isFrame ?? 0;
      form.redirect = menu.redirect || '';
      showModal.value = true;
    }

    // 获取父级菜单名称
    function getParentName(menuId) {
      for (const menu of menuTree.value) {
        if (menu.children) {
          const child = menu.children.find(c => c.id === menuId);
          if (child) return menu.name;
        }
      }
      return '';
    }

    // 关闭模态框
    function closeModal() {
      showModal.value = false;
      showIconSelector.value = false;
    }

    // 保存菜单
    async function saveMenu() {
      if (!form.name.trim()) {
        ElMessage.warning('请输入菜单名称');
        return;
      }
      if (form.type === TYPE_MENU && !form.path.trim()) {
        ElMessage.warning('请输入路由地址');
        return;
      }
      if ((form.type === TYPE_MENU || form.type === TYPE_BUTTON) && !form.perms.trim()) {
        ElMessage.warning('请输入权限标识');
        return;
      }
      const submitData = {
        name: form.name,
        type: form.type,
        status: form.status,
        parentId: form.parentId || 0,
        path: form.path || '',
        component: form.component || '',
        redirect: form.redirect || '',
        perms: form.perms || '',
        icon: form.icon || '',
        sort: form.sort ?? 1,
        visible: form.visible === 0 ? 0 : 1,
        isCache: form.isCache ?? 0,
        isFrame: form.isFrame ?? 0
      };
      try {
        if (isEdit.value) {
          // 编辑
          await updateMenu(form.id, submitData);
          ElMessage.success('修改成功');
        } else {
          // 新增
          await createMenu(submitData);
          ElMessage.success('新增成功');
        }
        await fetchMenuTree();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
        return;
      }
      closeModal();
    }

    // 删除菜单
    function deleteMenu(menu) {
      pendingDelete.value = menu;
      showDeleteModal.value = true;
    }

    // 确认删除
    async function confirmDelete() {
      if (!pendingDelete.value) return;
      try {
        await removeMenu(pendingDelete.value.id);
        ElMessage.success('删除成功');
        await fetchMenuTree();
      } catch (error) {
        ElMessage.error(error.message || '删除失败');
      } finally {
        pendingDelete.value = null;
        closeDeleteModal();
      }
    }

    // 关闭删除确认弹窗
    function closeDeleteModal() {
      showDeleteModal.value = false;
      pendingDelete.value = null;
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, null, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[16] || (_cache[16] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "菜单管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "维护菜单树、权限标识、图标及层级关系。")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
          class: "btn-secondary inline-flex items-center gap-1",
          onClick: toggleAllTrees
        }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        })], -1), _createTextVNode(" 展开/折叠 ", -1)]))]), _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "btn-primary inline-flex items-center gap-2",
          onClick: openAddRootModal
        }, [...(_cache[15] || (_cache[15] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 新增菜单 ", -1)]))])), [[_directive_permission, 'system:menu:add']])])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("table", _hoisted_6, [_cache[38] || (_cache[38] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "菜单名称"), _createElementVNode("th", {
          class: "data-table-th text-left w-24"
        }, "图标"), _createElementVNode("th", {
          class: "data-table-th text-left w-20"
        }, "类型"), _createElementVNode("th", {
          class: "data-table-th text-left w-20"
        }, "排序"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "权限标识"), _createElementVNode("th", {
          class: "data-table-th text-left w-24"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", _hoisted_7, [loading.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(3, n => {
          return _createElementVNode("tr", {
            key: n,
            class: "animate-pulse"
          }, [...(_cache[17] || (_cache[17] = [_createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "flex items-center gap-1"
          }, [_createElementVNode("div", {
            class: "w-4 h-4 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "w-4 h-4 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-4 w-24 bg-slate-200 rounded"
          })])], -1), _createElementVNode("td", {
            class: "data-table-td is-center"
          }, [_createElementVNode("div", {
            class: "w-5 h-5 bg-slate-200 rounded mx-auto"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-5 w-14 bg-slate-200 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-8 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-4 w-32 bg-slate-200 rounded"
          })], -1), _createElementVNode("td", {
            class: "data-table-td"
          }, [_createElementVNode("div", {
            class: "h-5 w-12 bg-slate-200 rounded-full"
          })], -1), _createElementVNode("td", {
            class: "data-table-td data-table-sticky-right data-table-sticky-action"
          }, [_createElementVNode("div", {
            class: "flex items-center gap-1"
          }, [_createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          }), _createElementVNode("div", {
            class: "h-8 w-8 bg-slate-200 rounded"
          })])], -1)]))]);
        }), 64)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuTree.value, menu => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: menu.id
          }, [_createElementVNode("tr", {
            class: "tree-row parent data-table-row",
            "data-id": menu.id,
            "data-has-children": menu.children && menu.children.length > 0
          }, [_createElementVNode("td", _hoisted_9, [_createElementVNode("div", _hoisted_10, [menu.children && menu.children.length > 0 ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass(["tree-toggle w-4 h-4 text-slate-400 cursor-pointer", {
              expanded: expandedIds.value.includes(menu.id)
            }]),
            onClick: $event => toggleTree(menu.id)
          }, [...(_cache[18] || (_cache[18] = [_createElementVNode("svg", {
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5l7 7-7 7"
          })], -1)]))], 10, _hoisted_11)) : (_openBlock(), _createElementBlock("span", _hoisted_12)), _cache[19] || (_cache[19] = _createElementVNode("svg", {
            class: "w-4 h-4 text-amber-500",
            fill: "currentColor",
            viewBox: "0 0 20 20"
          }, [_createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z",
            "clip-rule": "evenodd"
          })], -1)), _createElementVNode("span", _hoisted_13, _toDisplayString(menu.name), 1)])]), _createElementVNode("td", _hoisted_14, [getIconComponent(menu.icon) ? (_openBlock(), _createBlock(_resolveDynamicComponent(getIconComponent(menu.icon)), {
            key: 0,
            class: "w-5 h-5 text-slate-500 mx-auto"
          })) : (_openBlock(), _createElementBlock("svg", _hoisted_15, [...(_cache[20] || (_cache[20] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 6h16M4 12h16M4 18h16"
          }, null, -1)]))]))]), _createElementVNode("td", _hoisted_16, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", getTypeClass(menu.type)])
          }, _toDisplayString(getTypeText(menu.type)), 3)]), _createElementVNode("td", _hoisted_17, _toDisplayString(menu.sort), 1), _createElementVNode("td", _hoisted_18, _toDisplayString(menu.perms || '-'), 1), _createElementVNode("td", _hoisted_19, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", menu.status === STATUS_NORMAL ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
          }, [_createElementVNode("span", {
            class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1", menu.status === STATUS_NORMAL ? 'bg-green-500' : 'bg-red-500'])
          }, null, 2), _createTextVNode(" " + _toDisplayString(menu.status === STATUS_NORMAL ? '正常' : '停用'), 1)], 2)]), _createElementVNode("td", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_withDirectives((_openBlock(), _createElementBlock("button", {
            class: "table-action-button is-primary",
            title: "新增",
            "aria-label": "新增",
            onClick: $event => openAddModal(menu)
          }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1)]))], 8, _hoisted_22)), [[_directive_permission, 'system:menu:add']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "table-action-button is-primary",
            title: "修改",
            "aria-label": "修改",
            onClick: $event => openEditModal(menu)
          }, [...(_cache[22] || (_cache[22] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_23)), [[_directive_permission, 'system:menu:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除",
            onClick: $event => deleteMenu(menu)
          }, [...(_cache[23] || (_cache[23] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_24)), [[_directive_permission, 'system:menu:remove']])])])], 8, _hoisted_8), menu.children && menu.children.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
            key: 0
          }, _renderList(menu.children, child => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: child.id
            }, [_createElementVNode("tr", {
              class: "tree-row child data-table-row bg-slate-50/50",
              "data-parent-id": menu.id,
              style: _normalizeStyle({
                display: expandedIds.value.includes(menu.id) ? '' : 'none'
              })
            }, [_createElementVNode("td", _hoisted_26, [_createElementVNode("div", _hoisted_27, [child.children && child.children.length > 0 ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["tree-toggle w-4 h-4 text-slate-400 cursor-pointer", {
                expanded: expandedIds.value.includes(child.id)
              }]),
              onClick: $event => toggleTree(child.id)
            }, [...(_cache[24] || (_cache[24] = [_createElementVNode("svg", {
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 5l7 7-7 7"
            })], -1)]))], 10, _hoisted_28)) : (_openBlock(), _createElementBlock("span", _hoisted_29)), child.type === TYPE_BUTTON ? (_openBlock(), _createElementBlock("svg", _hoisted_30, [...(_cache[25] || (_cache[25] = [_createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z",
              "clip-rule": "evenodd"
            }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_31, [...(_cache[26] || (_cache[26] = [_createElementVNode("path", {
              d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
            }, null, -1)]))])), _createElementVNode("span", _hoisted_32, _toDisplayString(child.name), 1)])]), _createElementVNode("td", _hoisted_33, [child.type === TYPE_BUTTON ? (_openBlock(), _createElementBlock("span", _hoisted_34, "-")) : getIconComponent(child.icon) ? (_openBlock(), _createBlock(_resolveDynamicComponent(getIconComponent(child.icon)), {
              key: 1,
              class: "w-5 h-5 text-slate-500 mx-auto"
            })) : (_openBlock(), _createElementBlock("svg", _hoisted_35, [...(_cache[27] || (_cache[27] = [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4 6h16M4 12h16M4 18h16"
            }, null, -1)]))]))]), _createElementVNode("td", _hoisted_36, [_createElementVNode("span", {
              class: _normalizeClass(["status-badge", getTypeClass(child.type)])
            }, _toDisplayString(getTypeText(child.type)), 3)]), _createElementVNode("td", _hoisted_37, _toDisplayString(child.sort), 1), _createElementVNode("td", _hoisted_38, _toDisplayString(child.perms || '-'), 1), _createElementVNode("td", _hoisted_39, [_createElementVNode("span", {
              class: _normalizeClass(["status-badge", child.status === STATUS_NORMAL ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
            }, [_createElementVNode("span", {
              class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1", child.status === STATUS_NORMAL ? 'bg-green-500' : 'bg-red-500'])
            }, null, 2), _createTextVNode(" " + _toDisplayString(child.status === STATUS_NORMAL ? '正常' : '停用'), 1)], 2)]), _createElementVNode("td", _hoisted_40, [_createElementVNode("div", _hoisted_41, [child.type !== TYPE_BUTTON ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "table-action-button is-primary",
              title: "新增",
              "aria-label": "新增",
              onClick: $event => openAddModal(child)
            }, [...(_cache[28] || (_cache[28] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M12 4v16m8-8H4"
            })], -1)]))], 8, _hoisted_42)), [[_directive_permission, 'system:menu:add']]) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "table-action-button is-primary",
              title: "修改",
              "aria-label": "修改",
              onClick: $event => openEditModal(child)
            }, [...(_cache[29] || (_cache[29] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
            })], -1)]))], 8, _hoisted_43)), [[_directive_permission, 'system:menu:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "table-action-button is-danger",
              title: "删除",
              "aria-label": "删除",
              onClick: $event => deleteMenu(child)
            }, [...(_cache[30] || (_cache[30] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            })], -1)]))], 8, _hoisted_44)), [[_directive_permission, 'system:menu:remove']])])])], 12, _hoisted_25), expandedIds.value.includes(menu.id) && expandedIds.value.includes(child.id) ? (_openBlock(true), _createElementBlock(_Fragment, {
              key: 0
            }, _renderList(child.children, grandChild => {
              return _openBlock(), _createElementBlock("tr", {
                key: grandChild.id,
                class: "tree-row grand-child data-table-row bg-slate-100/50",
                "data-parent-id": child.id,
                style: {
                  "display": "table-row"
                }
              }, [_createElementVNode("td", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_cache[33] || (_cache[33] = _createElementVNode("span", {
                class: "w-4 h-4"
              }, null, -1)), grandChild.type === TYPE_BUTTON ? (_openBlock(), _createElementBlock("svg", _hoisted_48, [...(_cache[31] || (_cache[31] = [_createElementVNode("path", {
                "fill-rule": "evenodd",
                d: "M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z",
                "clip-rule": "evenodd"
              }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_49, [...(_cache[32] || (_cache[32] = [_createElementVNode("path", {
                d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
              }, null, -1)]))])), _createElementVNode("span", _hoisted_50, _toDisplayString(grandChild.name), 1)])]), _createElementVNode("td", _hoisted_51, [grandChild.type === TYPE_BUTTON ? (_openBlock(), _createElementBlock("span", _hoisted_52, "-")) : getIconComponent(grandChild.icon) ? (_openBlock(), _createBlock(_resolveDynamicComponent(getIconComponent(grandChild.icon)), {
                key: 1,
                class: "w-5 h-5 text-slate-500 mx-auto"
              })) : (_openBlock(), _createElementBlock("svg", _hoisted_53, [...(_cache[34] || (_cache[34] = [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 6h16M4 12h16M4 18h16"
              }, null, -1)]))]))]), _createElementVNode("td", _hoisted_54, [_createElementVNode("span", {
                class: _normalizeClass(["status-badge", getTypeClass(grandChild.type)])
              }, _toDisplayString(getTypeText(grandChild.type)), 3)]), _createElementVNode("td", _hoisted_55, _toDisplayString(grandChild.sort), 1), _createElementVNode("td", _hoisted_56, _toDisplayString(grandChild.perms || '-'), 1), _createElementVNode("td", _hoisted_57, [_createElementVNode("span", {
                class: _normalizeClass(["status-badge", grandChild.status === STATUS_NORMAL ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
              }, [_createElementVNode("span", {
                class: _normalizeClass(["w-1.5 h-1.5 rounded-full mr-1", grandChild.status === STATUS_NORMAL ? 'bg-green-500' : 'bg-red-500'])
              }, null, 2), _createTextVNode(" " + _toDisplayString(grandChild.status === STATUS_NORMAL ? '正常' : '停用'), 1)], 2)]), _createElementVNode("td", _hoisted_58, [_createElementVNode("div", _hoisted_59, [grandChild.type !== TYPE_BUTTON ? _withDirectives((_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "table-action-button is-primary",
                title: "新增",
                "aria-label": "新增",
                onClick: $event => openAddModal(grandChild)
              }, [...(_cache[35] || (_cache[35] = [_createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M12 4v16m8-8H4"
              })], -1)]))], 8, _hoisted_60)), [[_directive_permission, 'system:menu:add']]) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createElementBlock("button", {
                class: "table-action-button is-primary",
                title: "修改",
                "aria-label": "修改",
                onClick: $event => openEditModal(grandChild)
              }, [...(_cache[36] || (_cache[36] = [_createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
              })], -1)]))], 8, _hoisted_61)), [[_directive_permission, 'system:menu:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
                class: "table-action-button is-danger",
                title: "删除",
                "aria-label": "删除",
                onClick: $event => deleteMenu(grandChild)
              }, [...(_cache[37] || (_cache[37] = [_createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [_createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
              })], -1)]))], 8, _hoisted_62)), [[_directive_permission, 'system:menu:remove']])])])], 8, _hoisted_45);
            }), 128)) : _createCommentVNode("", true)], 64);
          }), 128)) : _createCommentVNode("", true)], 64);
        }), 128))])])])]), _createVNode(AppModal, {
          visible: showDeleteModal.value,
          size: "sm",
          "panel-class": "mx-4",
          onClose: closeDeleteModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "p-6 text-center"
          }, [_cache[39] || (_cache[39] = _createElementVNode("div", {
            class: "w-12 h-12 mx-auto mb-4 text-red-500"
          }, [_createElementVNode("svg", {
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          })])], -1)), _cache[40] || (_cache[40] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900 mb-2"
          }, "确定要删除吗？", -1)), _cache[41] || (_cache[41] = _createElementVNode("p", {
            class: "text-sm text-slate-500 mb-6"
          }, "删除后无法恢复，请确认是否删除。", -1)), _createElementVNode("div", {
            class: "flex items-center justify-center gap-3"
          }, [_createElementVNode("button", {
            onClick: closeDeleteModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmDelete,
            class: "btn-danger-secondary"
          }, "确定删除")])])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showModal.value,
          size: "lg",
          "panel-class": "mx-4",
          onClose: closeModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_63, [_createElementVNode("h3", _hoisted_64, _toDisplayString(isEdit.value ? '修改菜单' : '新增菜单'), 1), _createElementVNode("button", {
            onClick: closeModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
          }, [...(_cache[42] || (_cache[42] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_65, [_createElementVNode("input", {
            type: "hidden",
            value: form.id
          }, null, 8, _hoisted_66), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", null, [_cache[43] || (_cache[43] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "菜单类型", -1)), _createVNode(_component_el_select, {
            modelValue: form.type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.type = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "目录",
              value: TYPE_CATALOG
            }), _createVNode(_component_el_option, {
              label: "菜单",
              value: TYPE_MENU
            }), _createVNode(_component_el_option, {
              label: "按钮",
              value: TYPE_BUTTON
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[44] || (_cache[44] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "显示状态", -1)), _createVNode(_component_el_select, {
            modelValue: form.visible,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.visible = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "显示",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "隐藏",
              value: 0
            })]),
            _: 1
          }, 8, ["modelValue"])])]), _createElementVNode("div", null, [_cache[45] || (_cache[45] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "上级菜单", -1)), _createElementVNode("input", {
            type: "text",
            value: form.parentName || '顶级菜单无需选择',
            readonly: "",
            class: "form-readonly w-full"
          }, null, 8, _hoisted_68)]), _createElementVNode("div", null, [_cache[46] || (_cache[46] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode("菜单名称 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.name = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入菜单名称"
          }, null, 512), [[_vModelText, form.name]])]), _withDirectives(_createElementVNode("div", _hoisted_69, [_createElementVNode("div", null, [_cache[47] || (_cache[47] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "路由地址", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.path = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "如：system/user"
          }, null, 512), [[_vModelText, form.path]])]), _createElementVNode("div", null, [_cache[48] || (_cache[48] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "排序号", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.sort = $event),
            type: "number",
            class: "form-input w-full",
            placeholder: "数字越大越靠后"
          }, null, 512), [[_vModelText, form.sort, void 0, {
            number: true
          }]])])], 512), [[_vShow, form.type === TYPE_MENU]]), _withDirectives(_createElementVNode("div", null, [_cache[49] || (_cache[49] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "权限标识", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.perms = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "如：system:user:list"
          }, null, 512), [[_vModelText, form.perms]])], 512), [[_vShow, form.type === TYPE_MENU || form.type === TYPE_BUTTON]]), _withDirectives(_createElementVNode("div", null, [_cache[50] || (_cache[50] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "组件路径", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.component = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "如：system/user/index"
          }, null, 512), [[_vModelText, form.component]])], 512), [[_vShow, form.type === TYPE_MENU]]), _withDirectives(_createElementVNode("div", null, [_cache[51] || (_cache[51] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "菜单图标", -1)), _createElementVNode("div", _hoisted_70, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.icon = $event),
            type: "text",
            class: "form-input flex-1",
            placeholder: "点击选择图标",
            readonly: "",
            onClick: _cache[8] || (_cache[8] = $event => showIconSelector.value = true)
          }, null, 512), [[_vModelText, form.icon]]), _createElementVNode("button", {
            type: "button",
            class: "px-3 py-2 bg-slate-100 border border-slate-300 rounded-lg text-sm hover:bg-slate-200 transition-colors",
            onClick: _cache[9] || (_cache[9] = $event => showIconSelector.value = true)
          }, " 选择图标 ")])], 512), [[_vShow, form.type === TYPE_CATALOG || form.type === TYPE_MENU]])]), _createElementVNode("div", {
            class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-xl"
          }, [_createElementVNode("button", {
            onClick: closeModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: saveMenu,
            class: "btn-primary"
          }, "确定")])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showIconSelector.value,
          size: "lg",
          "panel-class": "mx-4",
          onClose: _cache[13] || (_cache[13] = $event => showIconSelector.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_71, [_cache[53] || (_cache[53] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "选择图标", -1)), _createElementVNode("button", {
            onClick: _cache[10] || (_cache[10] = $event => showIconSelector.value = false),
            class: "p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
          }, [...(_cache[52] || (_cache[52] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_72, [_createVNode(IconSelector, {
            modelValue: form.icon,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.icon = $event)
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_73, [_createElementVNode("button", {
            onClick: _cache[12] || (_cache[12] = $event => showIconSelector.value = false),
            class: "btn-secondary"
          }, "确定")])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      });
    };
  }
};